export default {
  notFoundTitle: "Хуудас олдсонгүй",
  notFoundContent: "Таны хайж буй хуудас олдсонгүй. URL-ийг шалгаад дахин оролдоно уу.",
  notFoundBtn: "Самбар хэсэг рүү буцах",
  notifyWarningTitle: "Warning",
  notifyErrorTitle: "Error",
  notifyInfoTitle: "Info"
};
